export const safeParseJson = (value, fallback = null) => {
    if (value === null || value === undefined) return fallback
    if (typeof value === 'object') return value

    const trimmed = String(value).trim()
    if (!trimmed || trimmed === 'null' || trimmed === 'undefined') return fallback

    try {
        return JSON.parse(trimmed)
    } catch (error) {
        return fallback
    }
}


// WEBPACK FOOTER //
// ./src/helpers/safe-json.js